import React, { useState, useCallback, useEffect } from "react";
import { graphql, useStaticQuery, withPrefix } from "gatsby";
import { Link } from "../link";
import NewNavigationMegamenu from "./new-navigation-megamenu";
import classNames from "classnames";
import useClickOut from "../../hooks/use-click-out";
import ChevronRight from "../../icons/chevron-right-light.svg";
import Logo from "../../icons/logo.svg";
import { normalizeRelativePath } from "../../utility/paths";
import ArrowRight from "../../icons/arrow-right-long-sharp-light.svg";
import ArrowRightBlack from "../../icons/arrow-right-long-sharp-light-black.svg";
import useBlockScroll from "../../hooks/use-block-scroll";
import NewNavigationMenuItem from "./new-navigation-menu-item";

const NewNavigation = ({
  navUp,
  mobileMenuVisible,
  children,
  newTopLeftMenu,
  newTopRightMenu,
  labelManagerLabels,
  bannerTop,
  bannerTopMenuHeight,
  menuConfig,
  hamburger,
}) => {
  const { newMainMenuFiltered, bannerMenu } = useStaticQuery(graphql`
    {
      newMainMenuFiltered {
        name
        navigationMenuItems {
          useCustomName
          name
          content {
            __typename
            ... on LiferayPage {
              id
              slug
              target
              liferayFields {
                title
              }
              showAsButton
              showAsButtonText
            }
            ... on LiferayPageExternalLink {
              id
              liferayFields {
                title
              }
              target
              externalLink
              showAsButton
              showAsButtonText
            }
            ... on LiferayPageLine {
              id
              slug
              liferayFields {
                title
              }
              showAsButton
              showAsButtonText
            }
            ... on LiferayPageCrossLine {
              id
              slug
              liferayFields {
                title
              }
              showAsButton
              showAsButtonText
            }
            ... on LiferayBannerMenu {
              newTitle: title
              image {
                value {
                  description
                }
                node {
                  gatsbyImageData(layout: FULL_WIDTH)
                  publicURL
                }
              }
              ctaLabel
              ctaLink
              ctaTarget
              ctaType
              abstract
            }
            ... on LiferayAcBannerMenu {
              newTitle: title
              cta {
                label
                slug
                target
              }
              image {
                value {
                  description
                }
                node {
                  gatsbyImageData(layout: FULL_WIDTH)
                  publicURL
                }
              }
            }
          }
          navigationMenuItems {
            useCustomName
            name
            content {
              __typename
              ... on LiferayPage {
                id
                liferayFields {
                  title
                }
                slug
                target
                menuImage {
                  node {
                    gatsbyImageData(width: 500, layout: CONSTRAINED)
                  }
                  value {
                    description
                  }
                }
              }
              ... on LiferayPageCrossLine {
                id
                liferayFields {
                  title
                }
                slug
                menuImage {
                  node {
                    gatsbyImageData(width: 500, layout: CONSTRAINED)
                  }
                  value {
                    description
                  }
                }
              }
              ... on LiferayPageExternalLink {
                id
                liferayFields {
                  title
                }
                externalLink
                target
                menuImage {
                  node {
                    gatsbyImageData(width: 500, layout: CONSTRAINED)
                  }
                  value {
                    description
                  }
                }
              }
              ... on LiferayPageLine {
                id
                liferayFields {
                  title
                }
                pageNameMenu
                slug
                lineImageFieldSet {
                  lineImage {
                    node {
                      gatsbyImageData(width: 500, layout: CONSTRAINED)
                    }
                  }
                  altImage
                }
                allBabelProdotto {
                  id
                }
              }
              ... on LiferayBannerMenu {
                newTitle: title
                image {
                  value {
                    description
                  }
                  node {
                    gatsbyImageData(layout: FULL_WIDTH)
                    publicURL
                  }
                }
                ctaLabel
                ctaLink
                ctaTarget
                ctaType
                abstract
              }
              ... on LiferayAcBannerMenu {
                newTitle: title
                cta {
                  label
                  slug
                  target
                }
                image {
                  value {
                    description
                  }
                  node {
                    gatsbyImageData(layout: FULL_WIDTH)
                    publicURL
                  }
                }
              }
            }
            navigationMenuItems {
              useCustomName
              name
              content {
                __typename
                ... on LiferayPage {
                  id
                  liferayFields {
                    title
                  }
                  slug
                  target
                }
                ... on LiferayPageCrossLine {
                  id
                  liferayFields {
                    title
                  }
                  slug
                }
                ... on LiferayPageExternalLink {
                  id
                  liferayFields {
                    title
                  }
                  externalLink
                  target
                }
                ... on LiferayPageLine {
                  id
                  liferayFields {
                    title
                  }
                  pageNameMenu
                  slug
                  allBabelProdotto {
                    id
                  }
                }
                ... on LiferayBannerMenu {
                  newTitle: title
                  image {
                    value {
                      description
                    }
                    node {
                      gatsbyImageData(layout: FULL_WIDTH)
                      publicURL
                    }
                  }
                  ctaLabel
                  ctaLink
                  ctaTarget
                  ctaType
                  abstract
                }
                ... on LiferayAcBannerMenu {
                  newTitle: title
                  cta {
                    label
                    slug
                    target
                  }
                  image {
                    value {
                      description
                    }
                    node {
                      gatsbyImageData(layout: FULL_WIDTH)
                      publicURL
                    }
                  }
                }
              }
              navigationMenuItems {
                useCustomName
                name
                content {
                  __typename
                  ... on LiferayPage {
                    id
                    liferayFields {
                      title
                    }
                    slug
                    target
                  }
                  ... on LiferayPageCrossLine {
                    id
                    liferayFields {
                      title
                    }
                    slug
                  }
                  ... on LiferayPageExternalLink {
                    id
                    liferayFields {
                      title
                    }
                    externalLink
                    target
                  }
                  ... on LiferayPageLine {
                    id
                    liferayFields {
                      title
                    }
                    pageNameMenu
                    slug
                    allBabelProdotto {
                      id
                    }
                  }
                  ... on LiferayBannerMenu {
                    newTitle: title
                    image {
                      value {
                        description
                      }
                      node {
                        gatsbyImageData(layout: FULL_WIDTH)
                        publicURL
                      }
                    }
                    ctaLabel
                    ctaLink
                    ctaTarget
                    ctaType
                    abstract
                  }
                  ... on LiferayAcBannerMenu {
                    newTitle: title
                    cta {
                      label
                      slug
                      target
                    }
                    image {
                      value {
                        description
                      }
                      node {
                        gatsbyImageData(layout: FULL_WIDTH)
                        publicURL
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      bannerMenu: liferayBannerMenu(isDefault: { eq: true }) {
        isDefault
        title
        image {
          value {
            description
          }
          node {
            gatsbyImageData(layout: FULL_WIDTH)
            publicURL
          }
        }
        ctaLabel
        ctaLink
        ctaTarget
        ctaType
        abstract
      }
    }
  `);

  const [openIdx, setOpenIdx] = useState(-1);
  const closeSubMenu = useCallback(() => setOpenIdx(-1), []);

  const isBrowser = () => typeof window !== "undefined";
  useBlockScroll(openIdx >= 0 || (isBrowser() && window.innerWidth < 992 && hamburger));
  const [support, setSupport] = useState(false);
  const [language, setLanguage] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const itemClick = (e) => {
    const clickIdx = parseInt(e.currentTarget.name);
    e.preventDefault();
    setOpenIdx((value) => (clickIdx === value ? -1 : clickIdx));
  };
  const submenuOpen = openIdx >= 0;
  const closeMenu = useCallback(() => {
    setOpenIdx(-1);
    setSupport(false);
    setLanguage(false);
  }, []);

  useEffect(() => {
    // Close submenu when header scrolls up or when mobile menu is closed
    if (navUp && !mobileMenuVisible) {
      closeMenu();
    }
  }, [closeMenu, navUp, mobileMenuVisible]);

  const subMenuRef = useClickOut(submenuOpen, closeMenu);

  const toggleSupport = useCallback(() => setSupport((value) => !value), []);
  const toggleLanguage = useCallback(() => setLanguage((value) => !value), []);

  const menuRef = useClickOut(menuOpen, setMenuOpen);

  const banners =
    newTopRightMenu && newTopRightMenu?.navigationMenuItems?.length
      ? newTopRightMenu.navigationMenuItems
          .filter((item) => item?.content && item?.content?.__typename === "LiferayBannerMenu")
          ?.slice(0, 2)
      : null;
  const columns =
    newTopRightMenu && newTopRightMenu?.navigationMenuItems?.length
      ? newTopRightMenu?.navigationMenuItems.filter(
          (item) =>
            item?.content &&
            item?.navigationMenuItems?.length &&
            item?.content?.__typename !== "LiferayBannerMenu" &&
            item?.content?.__typename !== "LiferayAcBannerMenu"
        )
      : null;

  const columnsFiltered = columns && !!banners ? columns?.slice(0, 3) : columns?.slice(0, 4);
  const newTopRightMenuFiltered = { navigationMenuItems: columnsFiltered };

  const showAsButtonPage = newMainMenuFiltered?.navigationMenuItems?.length
    ? newMainMenuFiltered.navigationMenuItems
        .filter(
          (item) =>
            item?.content &&
            item?.content?.__typename !== "LiferayBannerMenu" &&
            item?.content?.__typename !== "LiferayAcBannerMenu"
        )
        .filter(
          (item) => item?.content && item.content?.showAsButton && !item.navigationMenuItems?.length
        )
        ?.slice(-1)
    : [];

  const defaultBanner = !!bannerMenu ? bannerMenu : null;

  const pathPrefix = withPrefix("/");
  const languages = ["/de_CH/", "/fr_CH/", "/it_CH/"].includes(pathPrefix)
    ? ["de_CH", "fr_CH", "it_CH"]
    : ["/fr_BE/", "/nl_BE/"].includes(pathPrefix)
    ? ["fr_BE", "nl_BE"]
    : [];

  const languageItem = {
    content: {
      title: languages?.[languages.indexOf(pathPrefix.replaceAll("/", ""))]
        ?.split("_")[0]
        ?.replace("/", "")
        ?.toUpperCase(),
    },
    navigationMenuItems: languages?.length
      ? languages
          ?.filter((language) => language !== pathPrefix.replaceAll("/", ""))
          ?.map((language) => {
            return {
              content: {
                liferayFields: { title: language.split("_")[0]?.replace("/", "")?.toUpperCase() },
                path: language,
              },
            };
          })
      : [],
  };

  return (
    <div
      ref={menuRef}
      className={classNames("new-navigation w-lg-auto", {
        "new-navigation--open": mobileMenuVisible,
        "new-navigation--subopen": submenuOpen || support || language,
        "new-navigation--background": mobileMenuVisible && !submenuOpen,
        "hasBannerTop": bannerTop && bannerTopMenuHeight !== 0,
      })}
      style={{
        "--banner-top-height":
          bannerTop && bannerTopMenuHeight ? `${bannerTopMenuHeight}px` : "0px",
      }}
    >
      <div className="new-header-top new-header-top--menu-open d-lg-none">
        <div className="container-fluid wrapper">
          <div className="row">
            <div className="col-6">
              <div className="d-flex justify-content-start d-lg-none logo text-center new-header-top--menu-open__logo">
                <Link className="logo__link" to="/">
                  <Logo />
                </Link>
              </div>
            </div>
            <div className="col-6">
              <div className="d-flex justify-content-end d-lg-none new-header-top--menu-open__close">
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={classNames("new-navigation__container")} ref={subMenuRef}>
        <ul className="new-navigation__list d-flex flex-column flex-lg-row flex-wrap align-items-center justify-content-between justify-content-lg-center">
          {newMainMenuFiltered?.navigationMenuItems?.length > 0
            ? newMainMenuFiltered.navigationMenuItems
                .filter(
                  (item) =>
                    item?.content &&
                    item?.content?.__typename !== "LiferayBannerMenu" &&
                    item?.content?.__typename !== "LiferayAcBannerMenu"
                )
                .map((item, i) => (
                  <NewNavigationMenuItem
                    item={item}
                    open={i === openIdx}
                    close={closeSubMenu}
                    last={
                      newMainMenuFiltered.navigationMenuItems.filter(
                        (item) =>
                          item?.content &&
                          item?.content?.__typename !== "LiferayBannerMenu" &&
                          item?.content?.__typename !== "LiferayAcBannerMenu"
                      )?.length - 1
                    }
                    index={i}
                    submenuOpen={submenuOpen}
                    itemClick={itemClick}
                    showAsButtonPage={showAsButtonPage}
                    bannerTop={bannerTop}
                    bannerTopMenuHeight={bannerTopMenuHeight}
                    closeMenu={closeMenu}
                    children={children}
                    labelManagerLabels={labelManagerLabels}
                    bannerMenu={bannerMenu}
                    defaultBanner={defaultBanner}
                    key={i}
                  />
                ))
            : null}
        </ul>
        {newTopLeftMenu && newTopLeftMenu?.navigationMenuItems?.length > 0 && (
          <div className="d-lg-none">
            {newTopLeftMenu.navigationMenuItems.map((element, index) => (
              <div key={index}>
                {(element?.content?.liferayFields?.title ||
                  (!!element?.useCustomName && element?.name)) && (
                  <>
                    {element?.content?.slug ? (
                      <Link
                        to={normalizeRelativePath(element.content.slug)}
                        key={index}
                        className="new-navigation__page-link"
                      >
                        {!!element?.useCustomName && element?.name
                          ? element.name
                          : element.content?.liferayFields?.title}
                      </Link>
                    ) : element?.content?.externalLink ? (
                      <a
                        className="new-navigation__page-link"
                        href={element.content.externalLink}
                        target={element?.content?.target ? element.content.target[0] : ""}
                        rel={element.content?.target?.[0] === "_blank" ? "noopener noreferrer" : ""}
                      >
                        {!!element?.useCustomName && element?.name
                          ? element.name
                          : element?.content?.liferayFields?.title}
                      </a>
                    ) : null}
                  </>
                )}
              </div>
            ))}
          </div>
        )}
        {menuConfig?.languageActive && languages?.length > 0 && (
          <div className="new-navigation__list d-flex flex-column flex-lg-row flex-wrap align-items-center justify-content-between justify-content-lg-center">
            <div
              className={classNames(
                "new-navigation__item new-navigation__item--language d-lg-none",
                {
                  open: language,
                }
              )}
            >
              <div
                className={classNames(
                  "d-flex d-lg-inline-flex align-items-center new-navigation__button-wrapper "
                )}
              >
                <button
                  className="new-navigation__link first-level new-navigation__toggle new-navigation__page-link d-lg-none "
                  aria-label="Toggle button"
                  onClick={toggleLanguage}
                >
                  {languageItem.content?.title}
                  <ChevronRight />
                </button>
              </div>
              <div
                className={classNames(
                  "d-flex flex-column new-navigation__submenu new-navigation__submenu--content",
                  {
                    "new-navigation__submenu--open": language,
                  }
                )}
              >
                <div className="new-header-top new-header-top--submenu-open d-lg-none">
                  <div className="container-fluid wrapper">
                    <div className="row align-items-center">
                      <div className="col-3">
                        <button
                          className="new-navigation__subbutton new-navigation__subbutton--back d-flex align-items-center d-lg-none"
                          onClick={() => closeMenu()}
                        >
                          <ArrowRight />
                        </button>
                      </div>
                      <div className="col-6 d-flex justify-content-center new-navigation__submenu-title ">
                        {languageItem.content?.title}
                      </div>
                      <div className="col-3">
                        <div className="d-flex justify-content-end d-lg-none new-header-top--submenu-open__close ">
                          {children}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <NewNavigationMegamenu
                  labelManagerLabels={labelManagerLabels}
                  item={languageItem}
                  origin="language"
                />
              </div>
            </div>
          </div>
        )}
        {newTopRightMenuFiltered && (
          <div className="new-navigation__list d-flex flex-column flex-lg-row flex-wrap align-items-center justify-content-between justify-content-lg-center">
            <div
              className={classNames(
                "new-navigation__item new-navigation__item--support d-lg-none",
                {
                  open: support,
                }
              )}
            >
              <div
                className={classNames(
                  "d-flex d-lg-inline-flex align-items-center new-navigation__button-wrapper "
                )}
              >
                <button
                  className="new-navigation__link first-level new-navigation__toggle new-navigation__page-link d-lg-none new-navigation__link--support"
                  aria-label="Toggle button"
                  onClick={toggleSupport}
                >
                  {labelManagerLabels.support}
                  <ChevronRight />
                </button>
              </div>
              <div
                className={classNames(
                  "d-flex flex-column new-navigation__submenu new-navigation__submenu--content",
                  {
                    "new-navigation__submenu--open": support,
                  }
                )}
              >
                <div className="new-header-top new-header-top--submenu-open d-lg-none new-header-top--support">
                  <div className="container-fluid wrapper">
                    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions*/}
                    <div
                      className="d-flex align-items-center justify-content-between"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <button
                        className="new-navigation__subbutton new-navigation__subbutton--back d-flex align-items-center d-lg-none"
                        onClick={() => closeMenu()}
                      >
                        <ArrowRightBlack />
                      </button>

                      <button
                        className="col-6 d-flex justify-content-center new-navigation__submenu-title new-navigation__submenu-title--support"
                        onClick={() => closeMenu()}
                      >
                        {labelManagerLabels.support}
                      </button>

                      <div className="d-flex justify-content-end d-lg-none new-header-top--submenu-open__close new-header-top--submenu-open__close--support">
                        {children}
                      </div>
                    </div>
                  </div>
                </div>
                <NewNavigationMegamenu
                  labelManagerLabels={labelManagerLabels}
                  bannerMenu={banners}
                  item={newTopRightMenuFiltered}
                  origin="support"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewNavigation;
